import React from 'react';

import HighlightedText from '@marketing/components/highlighted_text';

import WallOfLoveSection from '../../../sections/wall_of_love';
import WaqeebHeadshot from './assets/waqeeb_headshot.png';

export default () => {
  return (
    <WallOfLoveSection
      title="See what IELTS students say"
      showAllQuotesOnMobile
      featuredQuote={{
        studentName: 'Waqeeb, Bangladesh',
        studentAffiliation: 'Academic IELTS · Band 8.0',
        content: (
          <>&quot;Magoosh is hands down the best online prep material out there. It has <HighlightedText color="#FCF0BF">the complete package</HighlightedText>. Thanks a ton to the wonderful Magoosh Team!&quot;</>
        ),
        image: {
          alt: 'Image of Waqeeb',
          height: 'auto',
          src: WaqeebHeadshot,
          width: '340px'
        }
      }}
      quotes={[
        {
          studentName: 'Honore, Congo',
          studentAffiliation: 'Academic IELTS',
          content: (
            <>&quot;The comments have been so <HighlightedText color="#FCF0BF">helpful in improving my writing</HighlightedText> for the IELTS writing of task 2. It was detailed, clear, concise, and to the point. I could see what I am doing well and what needed improvement. Many thanks!&quot;</>
          )
        },
        {
          studentName: 'Luis, Ecuador',
          studentAffiliation: 'Academic IELTS',
          content: (
            <>&quot;The Speaking Evaluation helped me a lot to know <HighlightedText color="#FCF0BF">what the Speaking Part could look like</HighlightedText> on the day of the test. I recommend it to all students who are registered on the platform. It is a great advantage to have evaluations like these.&quot;</>
          )
        },
        {
          studentName: 'Siddhartha, Canada',
          studentAffiliation: 'Academic IELTS · Band 7.0',
          content: (
            <>&quot;The prompt response I received from your side whenever I have a query all <HighlightedText color="#FCF0BF">helped me a lot to improve my score</HighlightedText>. Keep the good work going guys you have got a lot of students depending on you.&quot;</>
          )
        },
        {
          studentName: 'Ainun, Indonesia',
          studentAffiliation: 'Academic IELTS · Band 6.0',
          content: (
            <>&quot;But, with the Magoosh study plan, I became familiar with the test and was <HighlightedText color="#FCF0BF">able to increase my IELTS score</HighlightedText>.&quot;</>
          )
        }
      ]}
    />
  );
};
